import React from "react";
import { colors, spacing, typography, radius } from "../../utils/designTokens";
import { useToast } from "../../components/Toast";
import { topbarStyle, backBtn, ghostBtn, primaryBtn } from "./materialesUi";
import {
  MANUALES_VIDEO,
  manualVideoUrl,
  manualVideoIgUrl,
  manualPosterUrl,
  manualPageUrl,
} from "../../utils/manualesVideos";
import { FaArrowLeft, FaLink, FaWhatsapp, FaExternalLinkAlt } from "react-icons/fa";

/**
 * Visor de los videos de manuales para residentes (contenido de habitia.ai).
 * Solo lectura: el comercial los MUESTRA en reuniones o comparte el link por
 * WhatsApp. Cada tarjeta reproduce el video horizontal y ofrece:
 *   - Copiar link a la página del manual (video + texto + FAQ).
 *   - Copiar link del video vertical (para mandar por WhatsApp / Instagram).
 *   - Abrir la página en la web.
 */
export default function ManualesVideoViewer({ isMobile, onClose }) {
  const { showToast } = useToast();

  async function copiar(url, msg) {
    try {
      await navigator.clipboard.writeText(url);
      showToast(msg, "success");
    } catch {
      showToast("No se pudo copiar el link.", "error");
    }
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%", minHeight: 0 }}>
      <div style={topbarStyle}>
        <button onClick={onClose} style={backBtn} aria-label="Volver a materiales">
          <FaArrowLeft size={12} /> {isMobile ? "" : "Materiales"}
        </button>
        <div style={{ flex: 1, minWidth: 0, fontSize: typography.sizes.base, color: colors.gray900, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
          Manuales en video · Residentes
        </div>
      </div>

      <div style={{ padding: `${spacing[2]}px ${spacing[3]}px`, background: colors.primaryLighter, color: colors.primary, fontSize: typography.sizes.sm, flexShrink: 0 }}>
        Videos cortos narrados por Habi (habitia.ai). Mostralos en una reunión o compartí el link por WhatsApp para que la administradora o el vecino vean lo fácil que es.
      </div>

      <div style={{ flex: 1, minHeight: 0, overflow: "auto", background: "#E9EBEE", padding: isMobile ? 12 : spacing[4] }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: isMobile ? "1fr" : "repeat(auto-fill, minmax(320px, 1fr))",
            gap: spacing[4],
            maxWidth: 1100,
            margin: "0 auto",
          }}
        >
          {MANUALES_VIDEO.map((m) => (
            <div
              key={m.slug}
              style={{
                background: colors.white,
                border: `1px solid ${colors.gray200}`,
                borderRadius: radius.md,
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <video
                controls
                preload="none"
                poster={manualPosterUrl(m.slug)}
                style={{ width: "100%", aspectRatio: "16 / 9", background: "#000", display: "block" }}
              >
                <source src={manualVideoUrl(m.slug)} type="video/mp4" />
              </video>
              <div style={{ padding: spacing[3], display: "flex", flexDirection: "column", gap: 6, flex: 1 }}>
                <span style={{ fontSize: typography.sizes.md, color: colors.gray900 }}>{m.titulo}</span>
                <span style={{ fontSize: typography.sizes.sm, color: colors.gray600, flex: 1 }}>{m.desc}</span>
                <div style={{ display: "flex", gap: spacing[2], flexWrap: "wrap", marginTop: 4 }}>
                  <button
                    onClick={() => copiar(manualPageUrl(m.slug), "Link del manual copiado — pegalo en WhatsApp o mail.")}
                    style={{ ...primaryBtn, padding: "7px 10px", fontSize: typography.sizes.sm }}
                  >
                    <FaLink size={11} /> Copiar link
                  </button>
                  <button
                    onClick={() => copiar(manualVideoIgUrl(m.slug), "Link del video vertical copiado — ideal para WhatsApp.")}
                    style={{ ...ghostBtn, padding: "7px 10px", fontSize: typography.sizes.sm }}
                    title="Video vertical para WhatsApp / Instagram"
                  >
                    <FaWhatsapp size={11} color="#25D366" /> Video vertical
                  </button>
                  <a
                    href={manualPageUrl(m.slug)}
                    target="_blank"
                    rel="noreferrer"
                    style={{ ...ghostBtn, padding: "7px 10px", fontSize: typography.sizes.sm, textDecoration: "none" }}
                  >
                    <FaExternalLinkAlt size={10} /> Ver en la web
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
